/* ═══════════════════════════════════════════════════════════════════
   CLIENTELE CONCIERGE WIDGET — V2
   BRUTALIST CONCRETE × BRONZE ACCENT
   Embed: <script src="https://clientele-os-production.up.railway.app/static/chat.js" defer></script>
   ═══════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── CONFIG ─────────────────────────────────────── */
  const API_BASE        = 'https://clientele-os-production.up.railway.app';
  const STORAGE_SESSION = 'cl_concierge_session';
  const STORAGE_STATE   = 'cl_concierge_open';

  /* ── PALETTE — Concrete / Bronze ─────────────────── */
  const C = {
    bg:        '#080808',
    surface:   '#0D0D0D',
    surface2:  '#121212',
    border:    'rgba(255,255,255,0.08)',
    border2:   'rgba(255,255,255,0.14)',
    text:      '#ECEAE3',
    textMuted: '#8C8C8C',
    textDim:   '#484844',
    concrete:  '#8C8C8C',
    bronze:    '#C4956A',
    bronzeDim: 'rgba(196,149,106,0.12)',
    green:     '#3DFF96',
    red:       '#FF4040',
  };

  /* ── SESSION ─────────────────────────────────────── */
  function getSession() {
    let sid = localStorage.getItem(STORAGE_SESSION);
    if (!sid) {
      sid = 'cl-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
      localStorage.setItem(STORAGE_SESSION, sid);
    }
    return sid;
  }

  /* ── STYLES ─────────────────────────────────────── */
  function injectStyles() {
    const css = `
/* ── CONCIERGE WIDGET ───────────────────────────── */
#cl-concierge-root * { box-sizing: border-box; margin: 0; padding: 0; }

/* FAB ───────────────────────────────────────────── */
#cl-fab {
  position: fixed;
  bottom: 32px;
  right: 32px;
  width: 52px;
  height: 52px;
  background: ${C.concrete};
  border: none;
  cursor: pointer;
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.18s ease, transform 0.18s ease;
  font-family: 'Syne Mono', monospace;
  font-size: 9px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: ${C.bg};
  gap: 0;
  overflow: hidden;
}
#cl-fab:hover { background: #A8A8A8; transform: scale(1.04); }
#cl-fab.is-open { background: ${C.surface2}; border: 1px solid ${C.border2}; }
#cl-fab.is-open .cl-fab-icon-open  { display: none; }
#cl-fab.is-open .cl-fab-icon-close { display: flex; }
.cl-fab-icon-close { display: none; color: ${C.textMuted}; font-size: 20px; line-height: 1; }
.cl-fab-icon-open  { display: flex; }

/* PANEL ─────────────────────────────────────────── */
#cl-panel {
  position: fixed;
  bottom: 100px;
  right: 32px;
  width: 380px;
  max-width: calc(100vw - 32px);
  height: 560px;
  max-height: calc(100vh - 140px);
  background: ${C.surface};
  border: 1px solid ${C.border};
  display: flex;
  flex-direction: column;
  z-index: 99999;
  opacity: 0;
  pointer-events: none;
  transform: translateY(12px);
  transition: opacity 0.22s ease, transform 0.22s ease;
  overflow: hidden;
}
#cl-panel.is-visible {
  opacity: 1;
  pointer-events: all;
  transform: translateY(0);
}

/* PANEL HEADER ──────────────────────────────────── */
#cl-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid ${C.border};
  flex-shrink: 0;
  background: ${C.bg};
}
.cl-panel-title {
  font-family: 'Syne Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.26em;
  text-transform: uppercase;
  color: ${C.textMuted};
}
.cl-panel-title span {
  color: ${C.bronze};
  margin-right: 6px;
}
#cl-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: ${C.textDim};
  font-size: 18px;
  line-height: 1;
  padding: 4px;
  transition: color 0.15s ease;
  font-family: 'Syne Mono', monospace;
}
#cl-close-btn:hover { color: ${C.textMuted}; }

/* STATUS STRIP ──────────────────────────────────── */
#cl-status-strip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  border-bottom: 1px solid ${C.border};
  flex-shrink: 0;
  background: ${C.surface};
}
.cl-status-dot {
  width: 5px;
  height: 5px;
  background: ${C.green};
  border-radius: 50%;
  animation: cl-pulse 2.4s ease-in-out infinite;
  flex-shrink: 0;
}
@keyframes cl-pulse {
  0%, 100% { opacity: 0.6; }
  50%       { opacity: 1; }
}
.cl-status-text {
  font-family: 'Syne Mono', monospace;
  font-size: 9px;
  letter-spacing: 0.20em;
  text-transform: uppercase;
  color: ${C.textDim};
}

/* MESSAGES ──────────────────────────────────────── */
#cl-messages {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  scroll-behavior: smooth;
}
#cl-messages::-webkit-scrollbar { width: 3px; }
#cl-messages::-webkit-scrollbar-track { background: transparent; }
#cl-messages::-webkit-scrollbar-thumb { background: ${C.border}; }

/* Message Bubbles */
.cl-msg {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 88%;
}
.cl-msg--user { align-self: flex-end; align-items: flex-end; }
.cl-msg--assistant { align-self: flex-start; align-items: flex-start; }
.cl-msg--system { align-self: center; max-width: 100%; }

.cl-msg__role {
  font-family: 'Syne Mono', monospace;
  font-size: 8px;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: ${C.textDim};
}
.cl-msg--user .cl-msg__role   { color: ${C.concrete}; }

.cl-msg__text {
  font-family: 'Syne', sans-serif;
  font-size: 13px;
  line-height: 1.6;
  color: ${C.text};
  background: ${C.surface2};
  border: 1px solid ${C.border};
  padding: 12px 16px;
  letter-spacing: 0.01em;
}
.cl-msg--user .cl-msg__text {
  background: ${C.surface2};
  border-color: ${C.border2};
  color: ${C.text};
}
.cl-msg--system .cl-msg__text {
  background: transparent;
  border: none;
  font-family: 'Syne Mono', monospace;
  font-size: 9px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: ${C.textDim};
  text-align: center;
  padding: 0;
}

/* Typing indicator */
.cl-typing .cl-msg__text {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 14px 18px;
  min-width: 60px;
}
.cl-typing-dot {
  width: 4px;
  height: 4px;
  background: ${C.textDim};
  border-radius: 50%;
  animation: cl-type 1.2s ease-in-out infinite;
}
.cl-typing-dot:nth-child(2) { animation-delay: 0.2s; }
.cl-typing-dot:nth-child(3) { animation-delay: 0.4s; }
@keyframes cl-type {
  0%, 60%, 100% { opacity: 0.2; transform: scale(1); }
  30%            { opacity: 1;   transform: scale(1.3); }
}

/* WAITLIST FORM ─────────────────────────────────── */
.cl-waitlist-form {
  background: ${C.surface2};
  border: 1px solid ${C.border};
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 4px;
}
.cl-wl-title {
  font-family: 'Syne Mono', monospace;
  font-size: 9px;
  letter-spacing: 0.26em;
  text-transform: uppercase;
  color: ${C.bronze};
  margin-bottom: 4px;
}
.cl-wl-input {
  width: 100%;
  font-family: 'Syne Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  color: ${C.text};
  background: transparent;
  border: none;
  border-bottom: 1px solid ${C.border2};
  padding: 8px 0;
  outline: none;
  transition: border-color 0.15s ease;
}
.cl-wl-input::placeholder {
  color: ${C.textDim};
  font-size: 10px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}
.cl-wl-input:focus { border-bottom-color: ${C.concrete}; }
.cl-wl-submit {
  font-family: 'Syne Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  background: ${C.concrete};
  color: ${C.bg};
  border: 1px solid ${C.concrete};
  padding: 12px 20px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  align-self: flex-start;
}
.cl-wl-submit:hover {
  background: transparent;
  color: ${C.concrete};
}

/* INPUT AREA ────────────────────────────────────── */
#cl-input-area {
  display: flex;
  align-items: flex-end;
  gap: 0;
  border-top: 1px solid ${C.border};
  flex-shrink: 0;
  background: ${C.bg};
}
#cl-input {
  flex: 1;
  font-family: 'Syne', sans-serif;
  font-size: 13px;
  color: ${C.text};
  background: transparent;
  border: none;
  padding: 16px 20px;
  resize: none;
  outline: none;
  max-height: 120px;
  overflow-y: auto;
  line-height: 1.5;
}
#cl-input::placeholder {
  color: ${C.textDim};
  font-size: 12px;
  letter-spacing: 0.06em;
}
#cl-send-btn {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  background: none;
  border: none;
  border-left: 1px solid ${C.border};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${C.textDim};
  transition: color 0.15s ease, background 0.15s ease;
}
#cl-send-btn:hover { color: ${C.concrete}; background: ${C.surface2}; }
#cl-send-btn svg { width: 16px; height: 16px; }

/* MOBILE ────────────────────────────────────────── */
@media (max-width: 480px) {
  #cl-fab  { bottom: 20px; right: 20px; }
  #cl-panel {
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    height: 72vh;
    border-left: none;
    border-right: none;
    border-bottom: none;
  }
}
    `;
    const style = document.createElement('style');
    style.id = 'cl-concierge-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ── BUILD DOM ───────────────────────────────────── */
  function buildDOM() {
    const root = document.createElement('div');
    root.id = 'cl-concierge-root';
    root.innerHTML = `
      <!-- FAB BUTTON -->
      <button id="cl-fab" aria-label="Open Concierge" aria-expanded="false" aria-controls="cl-panel">
        <span class="cl-fab-icon-open">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        </span>
        <span class="cl-fab-icon-close">×</span>
      </button>

      <!-- PANEL -->
      <div id="cl-panel" role="dialog" aria-label="Clientele Concierge" aria-hidden="true">

        <!-- HEADER -->
        <div id="cl-panel-header">
          <p class="cl-panel-title"><span>◆</span>CONCIERGE</p>
          <button id="cl-close-btn" aria-label="Close">×</button>
        </div>

        <!-- STATUS -->
        <div id="cl-status-strip">
          <div class="cl-status-dot"></div>
          <p class="cl-status-text">Online · 3 Locations · All pairs authenticated</p>
        </div>

        <!-- MESSAGES -->
        <div id="cl-messages" role="log" aria-live="polite" aria-atomic="false"></div>

        <!-- INPUT -->
        <div id="cl-input-area">
          <textarea id="cl-input" rows="1" placeholder="Ask about inventory, sizes, drops…" aria-label="Your message"></textarea>
          <button id="cl-send-btn" aria-label="Send">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square">
              <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
            </svg>
          </button>
        </div>

      </div>
    `;
    document.body.appendChild(root);
  }

  /* ── HELPERS ─────────────────────────────────────── */
  let msgCount = 0;

  function appendMsg(role, text, id) {
    const msgs = document.getElementById('cl-messages');
    if (!msgs) return;
    msgCount++;
    const div = document.createElement('div');
    div.className = `cl-msg cl-msg--${role}`;
    if (id) div.id = id;
    const roleLabel = role === 'user' ? 'YOU' : role === 'system' ? '' : 'CONCIERGE';
    div.innerHTML = `
      ${roleLabel ? `<p class="cl-msg__role">${roleLabel}</p>` : ''}
      <div class="cl-msg__text">${text}</div>
    `;
    msgs.appendChild(div);
    msgs.scrollTop = msgs.scrollHeight;
    return div;
  }

  function showTyping() {
    const msgs = document.getElementById('cl-messages');
    if (!msgs || document.getElementById('cl-typing')) return;
    const div = document.createElement('div');
    div.className = 'cl-msg cl-msg--assistant cl-typing';
    div.id = 'cl-typing';
    div.innerHTML = `<div class="cl-msg__text"><span class="cl-typing-dot"></span><span class="cl-typing-dot"></span><span class="cl-typing-dot"></span></div>`;
    msgs.appendChild(div);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function hideTyping() {
    const t = document.getElementById('cl-typing');
    if (t) t.remove();
  }

  /* ── WAITLIST FORM ───────────────────────────────── */
  const NOTIFY_RE = /\b(notify|waitlist|alert|let me know|back in stock|my size)\b/i;

  function showWaitlistForm(productHint) {
    const msgs = document.getElementById('cl-messages');
    if (!msgs || document.getElementById('cl-waitlist-form')) return;
    const form = document.createElement('div');
    form.className = 'cl-msg cl-msg--assistant';
    form.innerHTML = `
      <div class="cl-waitlist-form" id="cl-waitlist-form">
        <p class="cl-wl-title">◆ Notify Me</p>
        <input class="cl-wl-input" id="cl-wl-product" type="text" placeholder="Product name" value="${productHint || ''}"/>
        <input class="cl-wl-input" id="cl-wl-size" type="text" placeholder="Size (e.g. US 10)"/>
        <input class="cl-wl-input" id="cl-wl-phone" type="tel" placeholder="Phone number"/>
        <button class="cl-wl-submit" id="cl-wl-submit-btn">ADD TO WAITLIST →</button>
      </div>
    `;
    msgs.appendChild(form);
    msgs.scrollTop = msgs.scrollHeight;
    document.getElementById('cl-wl-submit-btn').addEventListener('click', submitWaitlist);
  }

  async function submitWaitlist() {
    const product = document.getElementById('cl-wl-product')?.value.trim();
    const size    = document.getElementById('cl-wl-size')?.value.trim();
    const phone   = document.getElementById('cl-wl-phone')?.value.trim();
    if (!phone) {
      document.getElementById('cl-wl-phone')?.focus();
      return;
    }
    const form = document.getElementById('cl-waitlist-form');
    if (form) form.closest('.cl-msg')?.remove();
    appendMsg('system', 'Adding to waitlist…');
    try {
      const r = await fetch(API_BASE + '/api/concierge/waitlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, product_title: product, size })
      });
      const data = await r.json();
      if (r.ok) {
        appendMsg('assistant', data.message || 'You\'re on the list. We\'ll text you when it drops.');
      } else {
        appendMsg('assistant', 'Something went wrong. Call us at the store directly.');
      }
    } catch {
      appendMsg('assistant', 'Connection error. Try again or call us directly.');
    }
  }

  /* ── SEND MESSAGE ────────────────────────────────── */
  let isSending = false;

  async function sendMessage() {
    if (isSending) return;
    const input = document.getElementById('cl-input');
    if (!input) return;
    const text = input.value.trim();
    if (!text) return;

    if (NOTIFY_RE.test(text)) {
      appendMsg('user', text);
      input.value = '';
      input.style.height = 'auto';
      showWaitlistForm('');
      return;
    }

    isSending = true;
    input.disabled = true;
    appendMsg('user', text);
    input.value = '';
    input.style.height = 'auto';
    showTyping();

    const session = getSession();
    const assistantMsgId = 'cl-ai-' + Date.now();
    let assistantDiv = null;
    let assistantText = '';

    try {
      const res = await fetch(API_BASE + '/api/concierge/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text, session_id: session })
      });

      hideTyping();

      if (!res.ok) {
        appendMsg('assistant', 'Our system is momentarily unavailable. Please try again.');
        return;
      }

      if (res.headers.get('Content-Type')?.includes('text/event-stream') || res.headers.get('Content-Type')?.includes('application/x-ndjson')) {
        // Streaming
        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value);
          const lines = chunk.split('\n');
          for (const line of lines) {
            if (!line.trim()) continue;
            try {
              const parsed = JSON.parse(line);
              const token = parsed.token || parsed.text || parsed.content || '';
              if (token) {
                if (!assistantDiv) {
                  assistantDiv = appendMsg('assistant', '', assistantMsgId);
                }
                assistantText += token;
                const textEl = assistantDiv.querySelector('.cl-msg__text');
                if (textEl) textEl.textContent = assistantText;
                document.getElementById('cl-messages').scrollTop = 99999;
              }
            } catch {}
          }
        }
      } else {
        // Non-streaming fallback
        const data = await res.json();
        const reply = data.reply || data.message || data.content || '';
        appendMsg('assistant', reply);
        assistantText = reply;
      }

      if (!assistantDiv && !assistantText) {
        appendMsg('assistant', 'No stock found for that. Want me to add you to the waitlist?');
      }

      // Check if response suggests waitlist
      if (assistantText && NOTIFY_RE.test(assistantText) && !document.getElementById('cl-waitlist-form')) {
        setTimeout(() => showWaitlistForm(''), 800);
      }

    } catch (err) {
      hideTyping();
      appendMsg('assistant', 'Connection issue. Check your internet and try again.');
    } finally {
      isSending = false;
      input.disabled = false;
      input.focus();
    }
  }

  /* ── PANEL OPEN / CLOSE ─────────────────────────── */
  function openPanel() {
    const panel = document.getElementById('cl-panel');
    const fab   = document.getElementById('cl-fab');
    if (!panel || !fab) return;
    panel.classList.add('is-visible');
    panel.setAttribute('aria-hidden', 'false');
    fab.classList.add('is-open');
    fab.setAttribute('aria-expanded', 'true');
    localStorage.setItem(STORAGE_STATE, '1');
    if (!document.querySelector('#cl-messages .cl-msg')) {
      appendMsg('system', 'Concierge online');
      appendMsg('assistant', 'What are you looking for today? Tell me a style, size, or brand and I\'ll check our inventory across all three locations.');
    }
    setTimeout(() => document.getElementById('cl-input')?.focus(), 200);
  }

  function closePanel() {
    const panel = document.getElementById('cl-panel');
    const fab   = document.getElementById('cl-fab');
    if (!panel || !fab) return;
    panel.classList.remove('is-visible');
    panel.setAttribute('aria-hidden', 'true');
    fab.classList.remove('is-open');
    fab.setAttribute('aria-expanded', 'false');
    localStorage.removeItem(STORAGE_STATE);
  }

  /* ── INIT ────────────────────────────────────────── */
  function init() {
    if (document.getElementById('cl-concierge-root')) return;
    injectStyles();
    buildDOM();

    const fab      = document.getElementById('cl-fab');
    const closeBtn = document.getElementById('cl-close-btn');
    const input    = document.getElementById('cl-input');
    const sendBtn  = document.getElementById('cl-send-btn');

    fab?.addEventListener('click', function () {
      const panel = document.getElementById('cl-panel');
      panel?.classList.contains('is-visible') ? closePanel() : openPanel();
    });

    closeBtn?.addEventListener('click', closePanel);

    sendBtn?.addEventListener('click', sendMessage);

    input?.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
      }
    });

    input?.addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = Math.min(this.scrollHeight, 120) + 'px';
    });

    // Restore open state
    if (localStorage.getItem(STORAGE_STATE)) {
      openPanel();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
